import React from 'react';
import { Formik, Form } from 'formik';
import SelectField, { SelectOptions } from 'Components/Formik/SelectField';
import { useEffect } from 'react';
import { useState } from 'react';
import { getCompany } from 'utils/api/company';
import InputText from 'Components/Formik/InputText';
import { useContext } from 'react';
import { UserContext } from 'Components/Context/UserContext';
import SelectMultiField from 'Components/Formik/SelectMultiField';
import { createMissionSchema } from 'utils/validators/createMission';
import { createMission } from 'utils/api/mission';
import { toast } from 'react-toastify';

import DateSelector from 'Components/Formik/DateSelector';
import { listCompanyWallets } from 'utils/api/wallets';

interface AddMissionProps {
  cancel: (refresh?: boolean) => void;
}

const AddMission: React.FC<AddMissionProps> = ({ cancel }) => {
  const { user } = useContext(UserContext);

  const [groupsOptions, setGroupsOptions] = useState<SelectOptions>([]);
  const [companyValuesOptions, setCompanyValuesOptions] =
    useState<SelectOptions>([]);
  const [walletOptions, setWalletOptions] = useState<SelectOptions>([]);

  useEffect(() => {
    //get company groups
    if (!user?.companyId) return;
    getCompany(user?.companyId).then((company) => {
      const groups = company.groups;
      if (groups === undefined) return setGroupsOptions([]);
      const groupOptions = groups.map((group) => ({
        label: group.name,
        value: group._id,
      }));
      const values = company.values;
      const companyValuesOptions = values.map((companyValues) => ({
        label: companyValues.name,
        value: companyValues.name,
      }));
      setGroupsOptions(groupOptions);
      setCompanyValuesOptions(companyValuesOptions);
    });

    listCompanyWallets(user?.companyId).then((wallets) => {
      const walletOptions = wallets.map((wallet) => ({
        label: wallet.name,
        value: wallet.id,
      }));
      setWalletOptions([
        {
          label: 'Geral',
          value: 'general',
        },
        ...walletOptions
      ]);
    });
  }, [user]);

  const initialValues = {
    company: user?.companyId,
    name: '',
    description: '',
    companyValues: [] as SelectOptions,
    groups: [] as SelectOptions,
    startsAt: '',
    endsAt: '',
    meritus: '',
    approveType: 'simple' as 'simple',
    walletId: 'general',
  };

  const handleSubmit = (values: typeof initialValues, actions: any) => {
    /*  if (!user) throw new Error('userContext not defined');
    if (!user.companyId)
      throw new Error('user companyId on userContext not defined');*/
    const {
      name,
      description,
      companyValues,
      groups,
      startsAt,
      endsAt,
      meritus,
      approveType,
      walletId,
    } = values;
    const processedValues = {
      company: user?.companyId,
      name,
      groups: groups.map((x) => x.value),
      startsAt: new Date(startsAt),
      endsAt: new Date(new Date(endsAt).setHours(23)),
      companyValues: companyValues.map((x) => x.value),
      meritus: parseInt(meritus),
      approveType,
      description,
      walletId: walletId === 'general' ? undefined : walletId,
    };

    const promise = createMission(processedValues);
    toast.promise(promise, {
      pending: 'Criando missão',
      success: {
        render() {
          actions.setSubmitting(false);
          cancel(true);
          return 'Missão criada.';
        },
      },
      error: {
        render({ data }) {
          actions.setSubmitting(false);
          return 'Algo deu errado';
        },
      },
    });
  };

  return (
    <div className="bg-white p-8 rounded md:w-5/12">
      <Formik
        validationSchema={createMissionSchema}
        onSubmit={handleSubmit}
        initialValues={initialValues}
      >
        {({ isSubmitting }) => (
          <Form className="w-full">
            <p className="text-darker-90 text-2xl">Crie uma missão</p>
            <p className="mt-8">Nome:</p>
            <InputText name="name" placeholder="Digite o nome da missão" />
            <p className="mt-8">Descrição:</p>
            <InputText name="description" placeholder="Descreva a missão" />
            <p className="mt-8">Quantidade em meritus:</p>
            <InputText name="meritus" placeholder="Digite o valor" />
            <p className="mt-8">Data de início:</p>
            <DateSelector name="startsAt" className="text-xs z-50" />
            <p className="mt-8">Data de finalização:</p>
            <DateSelector name="endsAt" className="text-xs z-40" />
            <p className="mt-8">Tipo da missão:</p>
            <SelectField
              name="approveType"
              placeholder="Selecione o tipo da missão"
              options={[
                {
                  label: 'Com evidência',
                  value: 'proof',
                },
                {
                  label: 'Sem evidência',
                  value: 'simple',
                },
              ]}
              className="mt-2"
            />
            <p className="mt-8">Valores:</p>
            <SelectMultiField
              name="companyValues"
              options={companyValuesOptions}
              className="mt-2"
            />
            <p className="mt-8">Grupos:</p>
            <SelectMultiField
              name="groups"
              options={groupsOptions}
              className="mt-2"
            />
            <p className="mt-8">Carteira:</p>
            <SelectField
              name="walletId"
              placeholder="Selecione a carteira"
              options={walletOptions}
              className="mt-2"
            />
            <hr className="mt-8 border-lighter-70" />
            <div className="flex items-center justify-between mt-4">
              <div></div>
              <div className="flex items-center gap-2">
                <button
                  className="px-7 py-2 border rounded-full"
                  onClick={() => cancel()}
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="px-7 py-2 bg-primary-darker text-white rounded-full disabled:opacity-30"
                  disabled={isSubmitting}
                >
                  Adicionar
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddMission;
